import React, { useState, useEffect } from 'react';

import { setSelectBillingAddress } from '../../../../../redux/checkoutredux/actions/checkoutactions/fetchselectActions';
import BlockDeliveryMehod from "./BlockDeliveryMehod";


const BlockPayAddress = ({store}) => {
  //const [addressData, setAddressDataLocally] = useState(store.getState().adressdatacurrent.addressData);
  
 

  const [addressData, setAddressDataLocally] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    street: '',
    houseNumber: '',
    additionalInfo: '',
    country: '',
    state: '',
    zip: '',
    city: '',
    phone: ''
  });


  //console.log("Initialdata: ",initialAddressData);
  

  useEffect(() => {
    const initialAddressData = store.getState().checkoutcontext.checkoutcontextall.checkoutcontextselect?.select_billingaddressdata || {};

    console.log("The adressdata from select: ",initialAddressData);
    setAddressDataLocally(initialAddressData);

    const unsubscribe = store.subscribe(() => {
      const currentState = store.getState();
      if (currentState.checkoutcontext.checkoutcontextall.checkoutcontextselect.select_billingaddressdata) {
        setAddressDataLocally(currentState.checkoutcontext.checkoutcontextall.checkoutcontextselect.select_billingaddressdata || {});
      }
    });

    return unsubscribe;
  }, [store]);


  /*

  
  useEffect(() => {
    const initialAddressData = store.getState().payaddressdatacurrent?.payaddressData || {};
    setAddressDataLocally(initialAddressData);

    const unsubscribe = store.subscribe(() => {
      const currentState = store.getState();
      if (currentState.payaddressdatacurrent) {
        setAddressDataLocally(currentState.payaddressdatacurrent.payaddressData || {});
      }
    });

    return unsubscribe;
  }, [store]);
*/


const handleInputChange = (e) => {
  console.log("handlepayinput");
  let { id, value } = e.target;
  let updatedAddressData = { ...addressData, [id]: value };
  setAddressDataLocally(updatedAddressData);
  console.log("UPDATE BILLING: ",updatedAddressData);
  //store.dispatch(setPayAddressData(updatedAddressData));
  store.dispatch(setSelectBillingAddress(updatedAddressData));

 

};

  console.log("ADDRESSDATA: ",addressData);
  
  return (
    <form className="needs-validation" noValidate>
      <div id="ips-address-details" className="ips-module">
        <div className="row g-3 pt-2 pb-2">
         
          <div className="col-sm-6 ">
            <input type="text" className="form-control" id="firstName" placeholder="Vorname" required value={addressData.firstName} onChange={handleInputChange} />
            <div className="invalid-feedback">Ein gültiger Vorname ist erforderlich.</div>
          </div>
          <div className="col-sm-6">
            <input type="text" className="form-control" id="lastName" placeholder="Nachname" required value={addressData.lastName} onChange={handleInputChange} />
            <div className="invalid-feedback">Ein gültiger Nachname ist erforderlich.</div>
          </div>

          <div className="col-12">
            <input type="text" className="form-control" id="companyName" placeholder="Firmenname" value={addressData.companyName} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie einen gültigen Firmennamen ein.</div>
          </div>

          <div className="col-sm-8">
            <input type="text" className="form-control" id="street" placeholder="Straße" required value={addressData.street} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie Ihre Lieferadresse ein.</div>
          </div>

          <div className="col-sm-4">
            <input type="text" className="form-control" id="houseNumber" placeholder="Hausnummer" value={addressData.houseNumber} onChange={handleInputChange} />
          </div>

          <div className="col-12">
            <input type="text" className="form-control" id="additionalInfo" placeholder="Zusatz (Wohnung, Zimmer, Etage)" value={addressData.additionalInfo} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie Zusatzinfos an.</div>
          </div>

          <div className="col-md-5">
            <select className="form-select" id="country" required value={addressData.country} onChange={handleInputChange}>
              <option value="">Land auswählen...</option>
              <option>Vereinigte Staaten</option>
            </select>
            <div className="invalid-feedback">Bitte wählen Sie ein gültiges Land aus.</div>
          </div>
          <div className="col-md-4">
            <select className="form-select" id="state" required value={addressData.state} onChange={handleInputChange}>
              <option value="">Bundesland auswählen...</option>
              <option>Kalifornien</option>
            </select>
            <div className="invalid-feedback">Bitte geben Sie einen gültigen Status an.</div>
          </div>

          <div className="col-md-3">
            <input type="text" className="form-control" id="zip" placeholder="Postleitzahl" required value={addressData.zip} onChange={handleInputChange} />
            <div className="invalid-feedback">Postleitzahl erforderlich.</div>
          </div>

          <div className="col-12">
            <input type="email" className="form-control" id="city" placeholder="Ort/Stadt" value={addressData.city} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie den Ort/Stadt an.</div>
          </div>

          <div className="col-12">
            <input type="email" className="form-control" id="phone" placeholder="Telefon" value={addressData.phone} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Ihre Telefonnummer ein.</div>
          </div>
        </div>
      </div>
     
    </form>
  );
};

export default BlockPayAddress;